// On an Android phone in the browser: there's an app, with widgets.

import { Download, X } from 'lucide-react';
import { APP_APK, useAppPromo } from '../../data/androidApp.ts';
import { useProfile } from '../../data/hooks.ts';

export function AppPromo() {
  const { show, dismiss } = useAppPromo();
  const name = useProfile().name || 'Arlo';
  if (!show) return null;
  return (
    <section className="app-promo" aria-label="Arlo HQ for Android">
      <img className="app-promo-icon" src="./icons/icon-192.png" alt="" />
      <div className="app-promo-text">
        <strong>Arlo HQ for Android</strong>
        <span className="muted small">Opens full screen, with home-screen widgets: {name}’s next wee, and one-tap logging.</span>
        <div className="row app-promo-actions">
          <a className="btn btn-primary btn-sm" href={APP_APK} download>
            <Download className="btn-icon" aria-hidden />
            <span>Get the app</span>
          </a>
          <a className="btn btn-ghost btn-sm" href="#/settings/widgets">
            <span>How it works</span>
          </a>
        </div>
      </div>
      <button type="button" className="app-promo-close" aria-label="Not now" onClick={dismiss}>
        <X aria-hidden />
      </button>
    </section>
  );
}
